<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('information.fee.fee_details.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('information.title') }} > </span>
            <span class="middle_loc">{{ $t('information.fee.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.view') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2 my_app_tabs_data">
          <div class="board__re__view">
            <div class="board__re__header">
              <div class="numb__title">
                <div class="numb">No.{{ seq }}</div>
                <div class="title" v-if="$vuetify.rtl" >{{ viewNotice.subject_ar }}</div>
                <div class="title" v-if="!$vuetify.rtl" >{{ viewNotice.subject_en ? viewNotice.subject_en : viewNotice.subject_ar }}</div>
              </div>

              <div class="date">
                {{ viewNotice.write_date }}
                <span class="bar">|</span>
                <v-icon>mdi-eye</v-icon>
                <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                {{ viewNotice.read_count }}
              </div>


            </div>
            <div class="answ__content ty2">
              <div v-html="$vuetify.rtl ? viewNotice.content_ar : viewNotice.content_en" style="min-height: 300px"></div>
            </div>
          </div>


          <v-row class="board_views ma-0">
            <v-col cols="12" class="pa-0 d-flex mt-20">

              <v-spacer></v-spacer>
              <v-btn
                color="#acb0b3"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnGoList()"
              >
                {{ $t('common.button.go_to_list') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-flex>

      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import eventBus from '@/utils/eventBus'
import utils from '@/utils/utils'

export default {
  name : 'NoticeView',
  components :{
  },
  data () {
    return {
      seq : this.$route.params.seq,

      viewNotice : {
        subject_ar : '',
        subject_en : '',
        content_ar : '',
        content_en : '',
        seq : null,
        write_date : '',
        read_count : 0
      },
    }
  },
  created () {
    this.fnGetFeeView()
  },
  mounted(){
    window.scrollTo(0, 0)
  },
  methods: {
    fnGetFeeView(){
			requestApi({
        url: '/info/fee/' + this.seq + '?updateReadInd=Y',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
						this.viewNotice.seq = res.data.seq
            this.viewNotice.subject_ar = res.data.subject_ar
            this.viewNotice.subject_en = res.data.subject_en
            this.viewNotice.content_ar = res.data.content_ar
            this.viewNotice.content_en = res.data.content_en
            this.viewNotice.write_date = res.data.write_date
            this.viewNotice.read_count = res.data.read_count
					} else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetFeeView()
              })
            } else {
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnGetFeeView()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        }
      })
		},
    fnGoList(){
      let page = {
        name : 'Fee',
        params : {
          searchKeyword : this.$route.params.searchKeyword,
          page : this.$route.params.page,
          pageSize : this.$route.params.pageSize
        }
      }
      this.$router.push(page)
    }
  },
}
</script>